import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const level4: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W' },
        'WE',
        ['SE', 'WE'],
        'WE',
        { track: 'WE', vehicle: { type: 'locomotive', direction: -1 } },
        'WE',
        'WE',
        ['SW', 'WE'],
        'WE',
        'WE',
      ],
      'fill',
    ),
    padRow([null, null, 'NS', null, null, null, null, 'NS'], 'prepend', false),
    padRow(
      [
        'W',
        'WE',
        ['WE', 'NW'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'red', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'gold', direction: -1 } },
        'WE',
        ['WE', 'NE'],
        'WE',
        'E',
      ],
      'prepend',
      false,
    ),
  ],
  goal: {
    sequence: ['gold', 'blue', 'red'],
  },
}
